import { Controller } from "@hotwired/stimulus"
import TomSelect from "@lib/custom-tom-select"

export default class extends Controller {
  
  static targets = ["species", "breed"]
  
  connect() {
    // Destroy existing Tom Select instances if they exist (e.g., from previous connection)
    if (this.speciesTarget.tomselect) {
      this.speciesTarget.tomselect.destroy()
    }
    if (this.breedTarget.tomselect) {
      this.breedTarget.tomselect.destroy()
    }

    this.speciesSelect = new TomSelect(this.speciesTarget, { maxItems: 1, onChange: this.onSpeciesChange.bind(this) })
    this.breedSelect = new TomSelect(this.breedTarget, { maxItems: 1 })
  }

  disconnect() {
    if (this.speciesSelect) {
      this.speciesSelect.destroy()
    }
    if (this.breedSelect) {
      this.breedSelect.destroy()
    }
  }

  async onSpeciesChange() {
    if (!this.speciesTarget.value) return this.breedSelect.clearSelect()
    this.breedSelect.fetchOptions(`/api/v1/breeds?species_id=${this.speciesTarget.value}`, { focus: true })
  }
  
}
